import { defineComponent, ref, computed, watch, onMounted, provide } from '@vue/composition-api';
import { SdsAccordionContext } from './symbols.js';

var script = defineComponent({
    props: {
        // Used to scroll only after the content is loaded
        contentLoadingData: {
            type: Object,
            default: null,
        },
        openFirstAvailable: {
            type: Boolean,
            default: false,
        },
    },
    setup: function (props, _a) {
        var slots = _a.slots;
        var active = ref();
        var oldActive = ref();
        var uuid = ref(0);
        var scrollOffset = ref(0);
        // TODO: Try to think of a cleaner way
        var items = computed(function () {
            if (slots['default']) {
                var slotVNodes = slots['default'](); // Get VNodes from default slot
                return slotVNodes.map(function (vnode) {
                    // Extract component instance from VNode
                    var componentInstance = vnode.componentInstance;
                    // Extract props from component instance
                    return componentInstance === null || componentInstance === void 0 ? void 0 : componentInstance.$props;
                }).filter(function (item) { return item; });
            }
            return [];
        });
        var setActive = function (item) {
            if (!active.value || active.value.index !== item.index) {
                oldActive.value = active.value;
                active.value = item;
            }
            else {
                active.value = undefined;
            }
        };
        var getScrollOffset = function () {
            if (active.value && oldActive.value && oldActive.value.index < active.value.index) {
                return -oldActive.value.height;
            }
            return 0;
        };
        var scroll = function () {
            window.scrollBy(0, scrollOffset.value);
            scrollOffset.value = 0;
        };
        watch(function () { var _a; return (_a = active.value) === null || _a === void 0 ? void 0 : _a.index; }, function () {
            scrollOffset.value = getScrollOffset();
            scroll();
        });
        watch(function () { var _a; return (_a = props.contentLoadingData) === null || _a === void 0 ? void 0 : _a['isContentLoaded']; }, function (value) {
            if (value) {
                scroll();
            }
        });
        onMounted(function () {
            if (props.openFirstAvailable) {
                setActive({
                    index: items.value.findIndex(function (item) { return !item.isDisabled; }),
                    height: 0,
                });
            }
        });
        provide(SdsAccordionContext, {
            getUuid: function () {
                var id = uuid.value;
                uuid.value += 1;
                return id;
            },
            setActiveHeight: function (value) {
                active.value.height = value;
            },
            setActive: setActive,
            active: active,
        });
    },
});

export default script;
